import Tooltip from "@material-ui/core/Tooltip";
import React from "react";
import { FunctionField } from "react-admin";

const _getIsNullishSource = (_) => false;
const _getSource = (props) => props.source;

export const HighlightField = React.memo(
	({
		getHighlightValue,
		component: Component,
		emptyOnHighlight = false,
		getIsNullishSource = _getIsNullishSource,
		getSource = _getSource,
		...props
	}) => {
		const {
			sharedFieldsProps = {},
			editableComponentsProps = {},
			editableComponent: EditableComponent,
			...rest
		} = props;

		const renderField = (record) => {
			const { editableFieldProps = {}, ...restSharedFieldsProps } = sharedFieldsProps;
			const { editable = false, ...restEditableFieldsProps } = editableFieldProps;

			const payload = { ...rest, record };
			const highlightValue = getHighlightValue(payload);
			const targetSource = getSource(payload);

			const sharedSharedFieldsProps = { ...restSharedFieldsProps, source: targetSource };
			const sharedEditableFieldsProps = {
				...sharedSharedFieldsProps,
				...restEditableFieldsProps,
				...editableComponentsProps,
				editable,
			};

			if (highlightValue) {
				const isNullishSource = getIsNullishSource(payload);

				return (
					<Tooltip title={highlightValue} placement="top" className="cell-tooltip-highlight">
						<div>
							{editable && EditableComponent ? (
								<EditableComponent {...rest} {...sharedEditableFieldsProps} />
							) : !isNullishSource && !emptyOnHighlight ? (
								<Component {...rest} {...sharedSharedFieldsProps} />
							) : (
								<span>{"\u00A0"}</span>
							)}
						</div>
					</Tooltip>
				);
			} else {
				return <Component {...rest} {...sharedSharedFieldsProps} />;
			}
		};

		return <FunctionField {...rest} render={renderField} />;
	}
);
